export function emptySchemaData() {
    return { fields: [], elements: [], projects: [], projectFields: [], users: [], tags: [] };
}
export function indexSchema(data) {
    const fieldsByName = new Map();
    const fieldsById = new Map();
    for (const f of data.fields) {
        fieldsById.set(f.id, f);
        fieldsByName.set(f.name.toLowerCase(), f);
    }
    const projectFieldsByProject = new Map();
    for (const pf of [...data.projectFields].sort((a, b) => a.ordinal - b.ordinal || a.fieldId - b.fieldId)) {
        push(projectFieldsByProject, pf.projectId, pf);
        const def = fieldsById.get(pf.fieldId);
        if (def && pf.alias !== null && !fieldsByName.has(pf.alias.toLowerCase()))
            fieldsByName.set(pf.alias.toLowerCase(), def);
    }
    const elementsByBundle = new Map();
    const elementsById = new Map();
    for (const e of [...data.elements].sort((a, b) => a.bundleId - b.bundleId || a.ordinal - b.ordinal || a.id - b.id)) {
        push(elementsByBundle, e.bundleId, e);
        elementsById.set(e.id, e);
    }
    const projectsByName = new Map();
    const projectsById = new Map();
    for (const p of data.projects) {
        projectsById.set(p.id, p);
        projectsByName.set(p.key.toLowerCase(), p);
    }
    for (const p of data.projects)
        if (!projectsByName.has(p.name.toLowerCase()))
            projectsByName.set(p.name.toLowerCase(), p);
    const usersByName = new Map();
    const usersById = new Map();
    for (const u of data.users) {
        usersById.set(u.id, u);
        usersByName.set(u.login.toLowerCase(), u);
    }
    for (const u of data.users) {
        const local = u.login.split("@")[0]?.toLowerCase();
        if (local && !usersByName.has(local))
            usersByName.set(local, u);
    }
    for (const u of data.users)
        if (!usersByName.has(u.name.toLowerCase()))
            usersByName.set(u.name.toLowerCase(), u);
    const tagsByName = new Map();
    const tagsById = new Map();
    for (const t of data.tags) {
        tagsByName.set(t.name.toLowerCase(), t);
        tagsById.set(t.id, t);
    }
    const none = [];
    return {
        data,
        fieldsByName,
        fieldsById,
        elementsByBundle,
        elementsById,
        projectsByName,
        projectsById,
        projectFieldsByProject,
        usersByName,
        usersById,
        tagsByName,
        tagsById,
        bind(currentUserId, now = Date.now()) {
            return {
                currentUserId,
                now,
                fieldByName: (n) => fieldsByName.get(n.toLowerCase()),
                fieldById: (id) => fieldsById.get(id),
                elementsOf: (b) => elementsByBundle.get(b) ?? none,
                projectByName: (n) => projectsByName.get(n.toLowerCase()),
                userByName: (n) => usersByName.get(n.toLowerCase()),
                tagByName: (n) => tagsByName.get(n.toLowerCase()),
                allFields: () => data.fields,
            };
        },
    };
}
function push(m, k, v) {
    const list = m.get(k);
    if (list)
        list.push(v);
    else
        m.set(k, [v]);
}
//# sourceMappingURL=schema-data.js.map